@if (service.isOpened().status && form) {
  <div class="sidemenu" #sidemenu>
    <div class="dashboard" @fadeSlide>
      <form [formGroup]="form" class="edit h-100" (click)="$event.preventDefault()">
        <div class="row h-100">
          <div class="col-12 align-self-start">
            <div class="row title p-4">
              <div class="col-8">
                <h3 class="mb-0 fw-semibold">{{ title }}</h3>
              </div>
              <div class="col-4 text-end" (click)="close()" [@fadeSlide]>
                <img src="assets/images/icons/close.svg" alt="close" class="close" />
              </div>
            </div>
            <div
              class="row justify-content-center"
              [ngClass]="
                signal_value.title === 'languages' || signal_value.title === 'skills'
                  ? 'p-0'
                  : 'p-4'
              "
            >
              @if (isLoading) {
                <div class="col-12">
                  <p-skeleton width="25%" height="24px" styleClass=""></p-skeleton>
                  <p-skeleton width="100%" height="48px" styleClass="mb-3"></p-skeleton>
                  <p-skeleton width="20%" height="18px" styleClass="mb-3 ms-auto"></p-skeleton>
                  <p-skeleton width="25%" height="24px" styleClass=""></p-skeleton>
                  <p-skeleton width="100%" height="48px" styleClass="mb-3"></p-skeleton>
                  <p-skeleton width="25%" height="24px" styleClass=""></p-skeleton>
                  <p-skeleton width="100%" height="48px" styleClass="mb-3"></p-skeleton>
                </div>
              } @else {
                @switch (signal_value.title) {
                  @case ('photo') {
                    <div class="col-12">
                      <div class="image-wrapper m-auto">
                        @if (profile_image_url) {
                          <img [src]="profile_image_url" alt="profile" class="profile_img" />
                        } @else {
                          <img src="assets/images/icons/upload_placeholder.svg" alt="" />
                          <span class="text-dark d-inline-block mt-2">
                            <a class="text-default" (click)="uploadProfileImage()"> Upload </a>
                            image here.
                          </span>
                          <!-- <span> {{(signal_value.values.name)|titlecase |slice:0:1 }}</span>  -->
                        }
                        <div class="badge-img" (click)="uploadProfileImage()">
                          <img
                            src="assets/images/icons/{{
                              profile_image_url ? 'pencil' : 'plus'
                            }}.svg"
                            alt="icon"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="col-12 mt-3">
                      <ul class="text-dark photo_info">
                        <li>Maximum size 2MB</li>
                        <li>250px x 250px Min</li>
                        <li>Only JPG, JPEG, PNG, HEIC, WEBP supported</li>
                        <li>Clear, high-quality photo (not blurry or pixelated)</li>
                        <li>No filters, heavy edits, or logos instead of a face</li>
                      </ul>
                    </div>
                  }
                  @case ('intro') {
                    <div class="col-12">
                      <div class="user_name">
                        <app-input
                          type="text"
                          label="Full name"
                          placeholder="Enter Full Name"
                          formControlName="name"
                          [maxlength]="50"
                          [minlength]="3"
                          [submitted]="f['name'].touched"
                        >
                        </app-input>

                        <p class="text-dark">
                          We strongly recommend using your first name and first initial of your last
                          name.
                        </p>
                      </div>
                    </div>

                    <!-- @if(type=='freelancer') { -->
                    <div class="col-12">
                      <div class="headline">
                        <app-input
                          type="text"
                          label="Headline"
                          placeholder="Ex: Senior Design, Art director, Developer"
                          formControlName="headline"
                          [submitted]="f['headline'].touched"
                          [maxlength]="70"
                          [minlength]="3"
                        >
                        </app-input>
                      </div>
                    </div>
                    <!-- }  -->
                  }
                  @case ('about') {
                    <div class="col-12">
                      <!-- [minlength]="3" -->
                      <div class="about_me">
                        <app-textarea
                          [submitted]="f['about_me'].touched"
                          [rows]="5"
                          label="Description"
                          placeholder="Highlight your story and what makes you stand out to clients, your expertise, and what you offer."
                          formControlName="about_me"
                          [maxlength]="5000"
                          [minlength]="200"
                        >
                        </app-textarea>
                      </div>
                    </div>
                  }
                  @case ('skills') {
                    <div class="col-12">
                      <div class="skills">
                        <div class="p-4">
                          <label class="mb-2 fw-semibold">Skills</label>
                          <p-autoComplete
                            #auto
                            [(ngModel)]="currentSkill"
                            [ngModelOptions]="{ standalone: true }"
                            [suggestions]="filteredSkills"
                            (completeMethod)="search($event)"
                            (onSelect)="onSelectSkill($event)"
                            (keydown.enter)="onEnterSkill($event); $event.preventDefault()"
                            (onFocus)="onSkillFocus()"
                            [multiple]="false"
                            placeholder="Ex: Photoshop, Figma, Adobe"
                            [maxlength]="50"
                            (input)="currentSkill = $any($event.target).value"
                          >
                            <ng-template pTemplate="empty">
                              <span>Start typing to find skills</span>
                            </ng-template>
                          </p-autoComplete>
                          <div class="d-flex justify-content-end">
                            <small class="char-counter text-dark">
                              {{ 50 - (currentSkill?.length || 0) }} characters remaining
                            </small>
                          </div>
                        </div>

                        <div class="col-12 add-btn text-end">
                          <button
                            class="btn btn-dark text-white px-3 m-4"
                            (click)="addSkill()"
                            [ngClass]="{
                              'btn-dark': !currentSkill,
                              'btn-default': currentSkill,
                            }"
                          >
                            Add
                          </button>
                        </div>
                      </div>

                      <div class="selected_skills p-4">
                        <div class="d-flex flex-wrap gap-2">
                          @for (skill of selectedSkills; track skill) {
                            <div class="chip">
                              {{ skill }}
                              <span class="remove" (click)="removeSkill(skill)">
                                <img src="assets/images/icons/close.svg" height="25px" />
                              </span>
                            </div>
                          }
                        </div>
                      </div>
                    </div>
                  }
                  @case ('basic_info') {
                    @if (type == 'client') {
                      <div class="col-12">
                        <div class="company">
                          <app-input
                            type="text"
                            label="Company"
                            placeholder="Enter Company Name"
                            formControlName="company"
                            [submitted]="f['company'].touched"
                            [maxlength]="70"
                            [minlength]="3"
                          >
                          </app-input>
                        </div>
                      </div>
                    }

                    <div class="col-12">
                      <div class="country mb-3">
                        <label class="mb-2 fw-semibold">Country</label>
                        <p-dropdown
                          [options]="countries"
                          formControlName="country"
                          optionLabel="name"
                          optionValue="id"
                          placeholder="Select Country"
                          (onChange)="onCountryChange($event.value, false)"
                          [filter]="true"
                        >
                        </p-dropdown>
                      </div>
                    </div>

                    <div class="col-12">
                      <div class="city mb-3" [ngClass]="{ 'disable-city': !form.value.country }">
                        <label class="mb-2 fw-semibold">City</label>
                        <p-dropdown
                          [options]="cities"
                          formControlName="city"
                          optionLabel="name"
                          optionValue="id"
                          placeholder="Select City"
                          [filter]="true"
                        >
                        </p-dropdown>
                      </div>
                    </div>

                    @if (type == 'freelancer') {
                      <div class="col-12">
                        <div class="category">
                          <label class="mb-2 fw-semibold">Service Category</label>
                          <p-dropdown
                            [options]="categories"
                            optionLabel="name"
                            optionValue="id"
                            formControlName="category_id"
                            placeholder="Select Service Category"
                          >
                          </p-dropdown>
                        </div>
                      </div>
                    }
                  }
                  @case ('languages') {
                    <ng-container formArrayName="languages">
                      @for (group of languages.controls; track group) {
                        <ng-container [formGroupName]="$index">
                          <!-- {{this.form.value.languages[0].language_id |json}}  -->
                          <!-- Language -->
                          <div class="col-12 mb-3">
                            <div class="lang p-4 pb-0">
                              <label class="mb-2 fw-semibold">Language</label>
                              <p-dropdown
                                [options]="langs"
                                optionLabel="name"
                                optionValue="id"
                                formControlName="language_id"
                                placeholder="Select Language"
                              >
                              </p-dropdown>
                            </div>
                          </div>

                          <!-- Level -->
                          <div class="col-12 mb-3">
                            <div class="level px-4 pb-0">
                              <label class="mb-2 fw-semibold">Proficiency level</label>
                              <p-dropdown
                                [options]="levels"
                                formControlName="language_level"
                                placeholder="Select Proficiency level"
                              >
                              </p-dropdown>
                            </div>
                          </div>

                          <div class="col-12 text-end">
                            <div class="add_lang add-btn">
                              <button
                                class="btn btn-dark text-white m-4"
                                (click)="addNewLang($index)"
                                [ngClass]="{
                                  'btn-dark':
                                    !form.value.languages[0].language_id ||
                                    !form.value.languages[0].language_level,
                                  'btn-default':
                                    form.value.languages[0].language_id &&
                                    form.value.languages[0].language_level,
                                }"
                                [disabled]="
                                  !form.value.languages[0].language_id ||
                                  !form.value.languages[0].language_level
                                "
                              >
                                Add
                              </button>
                            </div>
                          </div>
                        </ng-container>
                      }
                    </ng-container>

                    <div class="col-12">
                      @for (lang of selectedLanguages; track lang) {
                        <div class="selected_lang px-4 py-2">
                          <div class="lang-chip">
                            <div class="row">
                              <div class="col-8">
                                <p class="text-black">{{ lang.name }}</p>
                                <span class="text-dark"> {{ lang.level }}</span>
                              </div>

                              <div class="col-4 text-end align-self-center">
                                <span
                                  class="ms-2 remove"
                                  (click)="deleteLanguage(lang.id, lang.level)"
                                >
                                  <img
                                    src="assets/images/icons/trash.svg"
                                    height="25px"
                                    alt="remove"
                                  />
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      }
                    </div>
                  }
                }
              }
            </div>
          </div>

          <div class="col-12 text-end align-self-end">
            <div class="save p-4">
              <button
                type="button"
                class="btn btn-default fw-semibold px-3 my-3"
                (click)="save()"
                [disabled]="isSaveDisabled()"
              >
                Save
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
}
